<template>
  <PublicShell :color="brand ? brand.color : null" narrow>
    <router-link :to="'/w/' + slug" class="pb-button link pb-back pr-back"><i class="mdi mdi-arrow-left" aria-hidden="true"></i> Back to the testimonials</router-link>
    <div class="pr-card">
      <template v-if="sent">
        <span class="pb-empty-icon" aria-hidden="true"><i class="mdi mdi-email-check-outline"></i></span>
        <h1 class="pr-title display-font">Request sent</h1>
        <p class="pb-body">{{ sent }}</p>
      </template>
      <form v-else novalidate @submit.prevent="send">
        <h1 class="pr-title display-font">Request removal</h1>
        <p class="pb-body pr-lead">Is one of these testimonials about you, or did you write one and want it removed? Tell {{ brand ? brand.name : 'the business' }}, and they will review it.
          If you have the withdrawal link you got after sending feedback, you can use it to remove your words at once.</p>
        <div class="pb-field"><label class="pb-label" for="pr-name">Your name</label>
          <input id="pr-name" v-model="name" class="pb-input" maxlength="120" autocomplete="name" :class="{ invalid: tried && !name.trim() }">
          <span v-if="tried && !name.trim()" class="pb-field-error">Please add your name.</span></div>
        <div class="pb-field"><label class="pb-label" for="pr-email">Your email</label>
          <input id="pr-email" v-model="email" type="email" class="pb-input" maxlength="255" autocomplete="email" :class="{ invalid: tried && !validEmail }">
          <span class="pb-help">Only {{ brand ? brand.name : 'the business' }} sees it, to reply to you.</span>
          <span v-if="tried && !validEmail" class="pb-field-error">Please check your email address.</span></div>
        <div v-if="items.length" class="pb-field"><label class="pb-label" for="pr-which">Which testimonial? <span class="optional">(optional)</span></label>
          <select id="pr-which" v-model="testimonial" class="pb-select"><option value="">I'm not sure</option>
            <option v-for="item in items" :key="item.ref" :value="item.ref">{{ (item.name || item.byline) + ': ' + short(item.text) }}</option></select></div>
        <div class="pb-field"><label class="pb-label" for="pr-message">Message <span class="optional">(optional)</span></label>
          <textarea id="pr-message" v-model="note" class="pb-textarea" rows="4" maxlength="2000"></textarea></div>
        <div v-if="error" class="pb-alert is-error" role="alert"><span>{{ error }}</span></div>
        <button type="submit" class="pr-send" :disabled="busy">{{ busy ? 'Sending…' : 'Send request' }}</button>
      </form>
    </div>
  </PublicShell>
</template>

<script>
import PublicShell from '../components/PublicShell.vue';
import { get, post, message } from '../api';

const EMAIL = /^[^@\s]{1,64}@[^@\s]{1,190}\.[^@\s]{2,}$/;

export default {
  name: 'PublicRemovalView',
  components: { PublicShell },
  data: () => ({ brand: null, items: [], name: '', email: '', testimonial: '', note: '', tried: false, busy: false, error: '', sent: '' }),
  computed: {
    slug() { return String(this.$route.params.slug || ''); },
    validEmail() { return EMAIL.test(this.email.trim()); }
  },
  async mounted() {
    try {
      const wall = await get('/public/walls/' + encodeURIComponent(this.slug), { removal: 1 });
      this.brand = wall.brand || null;
      this.items = wall.items || [];
    } catch (error) { /* the form works without the list */ }
    if (this.$route.query.ref) this.testimonial = String(this.$route.query.ref);
  },
  methods: {
    short(text) { return text.length > 60 ? text.slice(0, 59) + '…' : text; },
    async send() {
      this.tried = true;
      this.error = '';
      if (!this.name.trim() || !this.validEmail) return;
      this.busy = true;
      try {
        const result = await post('/public/walls/' + encodeURIComponent(this.slug) + '/removal-requests', {
          name: this.name.trim(), email: this.email.trim(), message: this.note.trim(), testimonial: this.testimonial || null });
        this.sent = result.message;
      } catch (error) { this.error = message(error, 'This page is not available.'); } finally { this.busy = false; }
    }
  }
};
</script>

<style scoped>
.pr-back{margin-bottom:16px}
.pr-card{background:#fff;border:1px solid #E6DED2;border-radius:20px;padding:32px}
.pr-title{font:500 30px/1.2 var(--font-display)!important;margin:0 0 10px}
.pr-lead{margin-bottom:22px}
.pr-send{width:100%;min-height:52px;border:0;border-radius:12px;background:var(--brand);color:var(--brand-on);font:600 16px var(--font-body);cursor:pointer}
.pr-send:disabled{opacity:.6;cursor:wait}
.pr-send:focus-visible{outline:2px solid #1F2328;outline-offset:2px}
@media(max-width:600px){.pr-card{padding:22px 16px}}
</style>
